import evmosLogoUrl from 'assets/images/evmos-logo.png' //TODO add
import arbitrumLogoUrl from 'assets/svg/arbitrum_logo.svg'
import ms from 'ms.macro'

import { SupportedChainId, SupportedL1ChainId, SupportedL2ChainId } from './chains'
import { ARBITRUM_LIST } from './lists'
export enum NetworkType {
  L1,
  L2,
}

interface BaseChainInfo {
  readonly networkType: NetworkType
  readonly blockWaitMsBeforeWarning?: number
  readonly docs: string
  readonly bridge?: string
  readonly explorer: string
  readonly infoLink: string
  readonly logoUrl: string
  readonly label: string
  readonly helpCenterUrl?: string
  readonly nativeCurrency: {
    name: string // e.g. 'Goerli ETH',
    symbol: string // e.g. 'gorETH',
    decimals: number // e.g. 18,
  }
}

export interface L1ChainInfo extends BaseChainInfo {
  readonly networkType: NetworkType.L1
  readonly statusPage?: string
}

export interface L2ChainInfo extends BaseChainInfo {
  readonly networkType: NetworkType.L2
  readonly bridge: string
  readonly statusPage?: string
  readonly defaultListUrl: string
}

export type ChainInfoMap = { readonly [chainId: number]: L1ChainInfo | L2ChainInfo } & {
  readonly [chainId in SupportedL2ChainId]: L2ChainInfo
} &
  { readonly [chainId in SupportedL1ChainId]: L1ChainInfo }

export const CHAIN_INFO: ChainInfoMap = {
  [SupportedChainId.MAINNET]: {
    networkType: NetworkType.L1,
    blockWaitMsBeforeWarning: ms`10m`,
    bridge: '/bridge',
    docs: 'https://evmos.io/',
    explorer: 'https://evmos.com/',
    infoLink: 'https://analytics.cronusfinance.xyz/#/evmos/',
    label: 'Evmos',
    logoUrl: evmosLogoUrl,
    nativeCurrency: { name: 'Evmos', symbol: 'EVMOS', decimals: 18 },
  },
  [SupportedChainId.EVMOS_TESTNET]: {
    networkType: NetworkType.L1,
    blockWaitMsBeforeWarning: ms`10m`,
    bridge: '/bridge',
    docs: 'https://evmos.io/',
    explorer: 'https://evmos.com/',
    infoLink: 'https://analytics.cronusfinance.xyz/#/evmos/',
    label: 'Evmos',
    logoUrl: evmosLogoUrl,
    nativeCurrency: { name: 'Evmos', symbol: 'tEVMOS', decimals: 18 },
  },
  [SupportedChainId.RINKEBY]: {
    networkType: NetworkType.L1,
    blockWaitMsBeforeWarning: ms`10m`,
    bridge: '/bridge',
    docs: 'https://evmos.io/',
    explorer: 'https://rinkeby.etherscan.io/',
    infoLink: 'https://analytics.cronusfinance.xyz/#/evmos/',
    label: 'Evmos',
    logoUrl: evmosLogoUrl,
    nativeCurrency: { name: 'Evmos', symbol: 'rEVMOS', decimals: 18 },
  },
  [SupportedChainId.NULL_CHAIN]: {
    networkType: NetworkType.L2,
    blockWaitMsBeforeWarning: ms`10m`,
    bridge: 'https://bridge.arbitrum.io/',
    docs: 'https://offchainlabs.com/',
    explorer: 'https://rinkeby-explorer.arbitrum.io/',
    infoLink: 'https://info.uniswap.org/#/arbitrum/',
    label: 'Arbitrum Rinkeby',
    logoUrl: arbitrumLogoUrl,
    defaultListUrl: ARBITRUM_LIST,
    helpCenterUrl: 'https://help.uniswap.org/en/collections/3137787-uniswap-on-arbitrum',
    nativeCurrency: { name: 'Rinkeby Arbitrum Ether', symbol: 'rinkArbETH', decimals: 18 },
  },
}
